import script from "./ConfigWarnings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigWarnings.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigWarnings.vue?vue&type=style&index=0&id=5e5f59b6&lang=css"

const __exports__ = script;

export default __exports__